"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getApproveAllKnocksLogPayload = getApproveAllKnocksLogPayload;
exports.getUserStartedStreamLogPayload = getUserStartedStreamLogPayload;
exports.getUserStoppedStreamLogPayload = getUserStoppedStreamLogPayload;
var _constants = require("@studio/constants");
function getStreamLogPayload(user, meeting) {
  var _id = user._id;
  var AttendeeId = meeting.attendeeResponse.Attendee.AttendeeId,
    MeetingId = meeting.meetingResponse.Meeting.MeetingId;
  return {
    userId: _id,
    meetingId: MeetingId,
    attendeeId: AttendeeId
  };
}
function getUserStartedStreamLogPayload(user, meeting) {
  var _getStreamLogPayload = getStreamLogPayload(user, meeting),
    userId = _getStreamLogPayload.userId,
    meetingId = _getStreamLogPayload.meetingId;
  return {
    title: "Stream started by user Id: ".concat(userId),
    view: _constants.DIRECTOR,
    'studio.meeting.id': meetingId
  };
}
function getUserStoppedStreamLogPayload(user, meeting) {
  var _getStreamLogPayload2 = getStreamLogPayload(user, meeting),
    userId = _getStreamLogPayload2.userId,
    meetingId = _getStreamLogPayload2.meetingId;
  return {
    title: "Stream stopped by user Id: ".concat(userId),
    view: _constants.DIRECTOR,
    'studio.meeting.id': meetingId
  };
}

/**
 * @param {Array} knocks
 * @param {{}} meeting
 */
function getApproveAllKnocksLogPayload(knocks, meeting) {
  var _knocks$map;
  var MeetingId = meeting.meetingResponse.Meeting.MeetingId;
  var knockIds = knocks === null || knocks === void 0 ? void 0 : (_knocks$map = knocks.map(function (knock) {
    return knock._id;
  })) === null || _knocks$map === void 0 ? void 0 : _knocks$map.join(',');
  return {
    view: _constants.DIRECTOR,
    'studio.meeting.id': MeetingId,
    title: "director mass approved knocks. Ids: ".concat(knockIds)
  };
}